import React, { Component } from 'react';
import { connect } from 'react-redux';
import className from 'classnames';
import totalBaseAndSVCFee from '../../selectors/totalBaseAndSVCFee.selector';
import totalBaseAndSVCFeeString from '../../selectors/totalBaseAndSVCFeeString.selector';

class TotalBaseAndSVCFee extends Component {
  render() {
    const { totalBaseAndSVCFee, totalBaseAndSVCFeeString, monthsFromNow, selectedMonthNumber } = this.props;
    // const noprint = className({
    //   'Row': true,
    //   'no-print': Number(totalBaseAndSVCFee) === 0,
    // });

    return (
      <div className="Row">
        <input tabIndex="-1" className="Row-total" data-id="totalBaseAndSVCFee" id="Rsub1a" data-tooltip="Registration fees (Total State &amp; County)" type="text" value={totalBaseAndSVCFee} readOnly />
        <span id="totalBaseAndSVCFeeString" dangerouslySetInnerHTML={{ __html: totalBaseAndSVCFeeString }} />
        <input id="monthset" value={monthsFromNow} readOnly className="u-hidden" />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    totalBaseAndSVCFee: totalBaseAndSVCFee(state),
    monthsFromNow: state.registration.monthsFromNow,
    totalBaseAndSVCFeeString: totalBaseAndSVCFeeString(state),
    selectedMonthNumber: state.registration.selectedMonthNumber,
  };
};

export default connect(mapStateToProps)(TotalBaseAndSVCFee);



// WEBPACK FOOTER //
// ./src/containers/registration/TotalBaseAndSVCFee.js